var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSherpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 80.5,
    r: 60,
    fill: "#D3F8E4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1006_1844",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 121,
    height: 121
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 80.5,
    r: 50,
    fill: "#0C8F63",
    stroke: "black",
    strokeWidth: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1006_1844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.4694 204.444L66.4726 174.847C60.3923 160.992 61.827 145.25 70.3164 132.736L81.9667 115.55L91.0199 129.144C100.38 143.203 100.76 161.618 91.9981 176.053L87.8973 182.81C86.4204 185.242 86.148 188.219 87.1493 190.881L90.4982 199.773C90.7015 199.539 90.8895 199.285 91.0583 199.009L101.489 181.831C112.483 163.719 112 140.618 100.257 122.983L82.0511 95.6367L61.1289 126.49C50.476 142.197 48.673 161.948 56.3107 179.326L69.3075 208.927C74.8238 221.488 75.0271 235.408 69.8791 248.127C69.4187 249.271 68.92 250.385 68.383 251.48L47.6871 239.403C29.6266 228.863 7.55741 227.903 -11.347 236.818L-51.4997 255.763L-11.3854 281.077C-1.12757 287.55 10.6493 290.849 22.4914 290.849C30.5933 290.849 38.7221 289.301 46.4058 286.171C61.8999 279.855 73.8878 267.825 80.1675 252.302C86.4473 236.776 86.1979 219.782 79.4655 204.448L79.4694 204.444ZM42.2206 275.868C26.6153 282.233 8.79264 280.662 -5.46622 271.67L-28.4293 257.173L-6.60939 246.874C8.99596 239.515 27.2022 240.31 42.1017 249.006L62.4293 260.864C57.1508 267.437 50.2688 272.592 42.2283 275.868H42.2206Z",
    fill: "#094B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2081 232.141V219.649C48.2081 214.71 47.0343 209.846 44.8055 205.441C29.4341 175.06 33.7459 137.504 56.3714 111.434L63.9861 102.664C66.9092 99.2952 68.5166 94.993 68.5166 90.5333V80.5L47.9933 104.139C34.3022 119.907 26.2732 139.256 24.7579 160.087C23.2465 180.926 28.4022 201.231 39.6689 218.812L48.2043 232.137L48.2081 232.141Z",
    fill: "#094B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.649 111.434C131.275 137.504 135.583 175.06 120.215 205.441C117.986 209.846 116.812 214.709 116.812 219.645V232.137L125.348 218.812C136.611 201.231 141.77 180.926 140.255 160.087C138.744 139.252 130.711 119.904 117.023 104.139L96.5001 80.5V90.5333C96.5001 94.9892 98.1075 99.2952 101.027 102.664L108.645 111.434H108.649Z",
    fill: "#094B38"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.3015,
    cy: 62.3011,
    r: 13.3509,
    stroke: "#094B38",
    strokeWidth: 8.90057
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 80.5,
    r: 56,
    stroke: "#094B38",
    strokeWidth: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSherpa);
export default __webpack_public_path__ + "static/media/Sherpa.8750fa71e5828eea21eb2d5cbedd28c7.svg";
export { ForwardRef as ReactComponent };